import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Provider, useDependencies, useOptionalDependencies, } from '@servicetitan/react-ioc';
import { ConnectionService } from './connection-service';
import { LOG_PARENT_TOKEN, Log } from './log';
import { LOG_CONFIG_TOKEN, defaultLogConfig } from './log-config';
import { LogSender } from './log-sender';
import { LogStorage } from './log-storage';
export const LogService = ({ children, endpoint = defaultLogConfig.endpoint, storageKey = defaultLogConfig.storageKey, }) => {
    const [parentLog] = useOptionalDependencies(Log);
    const singletons = useMemo(() => {
        const result = [
            { provide: LOG_CONFIG_TOKEN, useValue: { endpoint, storageKey } },
            ConnectionService,
            Log,
            LogStorage,
            LogSender,
        ];
        if (parentLog) {
            result.push({ provide: LOG_PARENT_TOKEN, useValue: parentLog });
        }
        return result;
    }, [endpoint, parentLog, storageKey]);
    return (_jsxs(Provider, { singletons: singletons, children: [_jsx(InitializeLogSender, {}), children] }));
};
const InitializeLogSender = () => {
    useDependencies(LogSender);
    return null;
};
//# sourceMappingURL=log-service.js.map